























































import Vue from 'vue';
import Component from 'vue-class-component';
import Heading from '../components/Heading.vue';
import Errors from '../components/Errors.vue';
import { AuthCredentials } from '../store/authStore.d';

const loginCredentials: AuthCredentials = {
  email: '',
  password: '',
};

@Component({
  name: 'Login',

  components: {
    Heading,
    Errors,
  },
})
export default class Login extends Vue {
  formInput = loginCredentials;

  showPasswordField = false;

  errors: Array<string> = [];

  $refs!: {
    passwordField: HTMLInputElement;
  }

  validate() {
    if (!this.formInput.email) {
      this.errors.push('Voer een e-mailadres in');
    }

    if (this.showPasswordField && !this.formInput.password) {
      this.errors.push('Voer een wachtwoord in');
    }

    return this.errors.length === 0;
  }

  loginCheck() {
    this.$store
      .dispatch('loginCheck', this.formInput.email)
      .then(({ data }) => {
        this.handleLoginCheck(data);
      });
  }

  handleLoginCheck(status: string) {
    this.errors = [];

    if (status === 'no_password') {
      // Redirect to password sent page
      this.$router.push({
        name: 'DynamicPage',
        params: { page: 'wachtwoord-aangevraagd' },
      });
    } else if (status === 'no_user') {
      this.errors.push(`
        Er is geen gebruiker met dit e-mailadres. Probeer een ander
        e-mailadres of maak een account aan.
      `);
    } else {
      this.showPasswordField = true;

      if (this.$refs.passwordField) {
        this.$nextTick(() => {
          this.$refs.passwordField.focus();
        });
      }
    }
  }

  login() {
    if (!this.showPasswordField) {
      this.loginCheck();

      return;
    }

    this.errors = [];

    if (!this.validate()) {
      return;
    }

    this.$store
      .dispatch('login', this.formInput)
      .then(() => {
        this.$router.push({ name: 'Home' });
      })
      .catch((err: Error) => {
        // eslint-disable-next-line no-console
        console.log(err);
        this.errors = ['Deze gegevens zijn onjuist, probeer het opnieuw of neem contact op'];
      });
  }
}
